/* global flowplayer:writable */
import "@babel/polyfill"
import * as adapter     from './video-adapter'
import * as native      from './native-interface'
import * as qs          from './qs'
import * as util       from './util'
import "./style/controls.sass"

window.controls = async function(elem, config = {}) {
  var fputil = flowplayer.util
  var Params = new qs.Params()

  window.addEventListener("error", function (e) {
    var err = e.error || {}
    console.error([
      err.message
      , err.stack
    ].join("\n"))

    native.notify_error(err.message)
  })
  
  var params = Params.parse()
  
  var options = fputil.assign(
      { src:                        ""
        , rewind:                   false
        , auto_orient:              false
        , muted:                    false
        , _video_element_callback:  adapter.create_video_element
        , ui:                       flowplayer.ui.NO_VOLUME_CONTROL | flowplayer.ui.NO_MUTE
      }, params, config)

  // Do not use value stored to local storage
  flowplayer.storage.removeItem ("mute", options.muted)
  
  // Reset volume if not muted and volume == 0
  var vol = flowplayer.storage.getItem("volume")
  if (!options.muted && (!vol || vol == 0) || params.volume) {
    flowplayer.storage.setItem("volume", params.volume || 1.0)
  }
  
  params.plugins && params.plugins.length && await util.load_scripts(params.plugins)
  
  var player = flowplayer(elem, options)
  
  if (player && player.root) {
    window.player = player
    player.root.addClass("is-idle")
    player.root.removeClass("is-muted")
    onPlayerEvent("idle")
  }
  return player
}
